import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "./Style/style.scss";
import App from './App';
import { Provider } from "react-redux";
import { createStore } from "redux";
import * as serviceWorker from './serviceWorker';
import AppReducer from "./Redux/Reducers";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
export const store = createStore(AppReducer);
export const persistor = persistStore(store);
ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
